export default "__VITE_ASSET__n09M1dhk__"